export default "__VITE_ASSET__f369e2b0__"